import { render, staticRenderFns } from "./CanPedalsure.vue?vue&type=template&id=913189f8&scoped=true"
import script from "./CanPedalsure.vue?vue&type=script&lang=js"
export * from "./CanPedalsure.vue?vue&type=script&lang=js"
import style0 from "./CanPedalsure.vue?vue&type=style&index=0&id=913189f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "913189f8",
  null
  
)

export default component.exports